/**
 * ALL CAPS Motion System
 * Scroll-triggered reveals · Stats count-up · Staggered entrances
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* =========================================================================
     1. SCROLL REVEAL — IntersectionObserver for [data-reveal] elements
     ========================================================================= */
  const revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -32px 0px',
    }
  );

  function initReveal() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* =========================================================================
     2. STATS COUNT-UP
     Targets the homepage stats bar (section_peaLtk) and animates numbers.
     ========================================================================= */
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCount(el, target, suffix, duration) {
    var start = null;
    var originalText = el.textContent;

    // Wrap in a span so layout doesn't shift
    var span = document.createElement('span');
    span.className = 'allcaps-stat-counting';
    span.textContent = '0' + suffix;
    el.textContent = '';
    el.appendChild(span);

    function step(timestamp) {
      if (!start) start = timestamp;
      var elapsed = timestamp - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeOutCubic(progress);
      var current = Math.round(eased * target);
      span.textContent = current + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        span.textContent = target + suffix;
      }
    }

    requestAnimationFrame(step);
  }

  function initStatsCountUp() {
    var statsSection = document.querySelector('#shopify-section-section_peaLtk');
    if (!statsSection) return;

    var headings = statsSection.querySelectorAll('h1, h2, h3, h4');
    var triggered = false;

    var countObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !triggered) {
            triggered = true;
            headings.forEach(function (el) {
              var text = el.textContent.trim();
              // Match patterns like "25G", "25", "100%" — but not pure text like "AUTHENTIC"
              var match = text.match(/^(\d+\.?\d*)([A-Za-z%+]*)$/);
              if (match) {
                var target = parseFloat(match[1]);
                var suffix = match[2] || '';
                // Only animate if the number is worth animating (>0)
                if (target > 0) {
                  animateCount(el, target, suffix, 1300);
                }
              }
            });
            countObserver.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );

    countObserver.observe(statsSection);
  }

  /* =========================================================================
     3. STAGGERED SECTION ENTRANCE
     Adds [data-section-reveal] to selected custom sections for entrance.
     ========================================================================= */
  function initSectionReveals() {
    var sectionSelectors = [
      '#shopify-section-allcaps_ingredient_badges',
      '#shopify-section-allcaps_belief_rail',
      '#shopify-section-section_x8mrnx',
      '#shopify-section-section_peaLtk',
      '#shopify-section-allcaps_product_stats',
    ];

    sectionSelectors.forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;
      el.setAttribute('data-section-reveal', '');
      revealObserver.observe(el);
    });
  }

  /* =========================================================================
     4. INIT — run after DOM is ready
     ========================================================================= */
  function init() {
    initReveal();
    initSectionReveals();
    initStatsCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on Shopify section renders in theme editor
  document.addEventListener('shopify:section:load', init);
})();
